import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux'

class Greetings extends React.Component {
  render() {
    const isBDay = moment().format('M-D') === '4-20';
    let text = 'Добро пожаловать!';
    if (isBDay) {
      text = 'С днём рождения, Денис!';
    }
    if (this.props.auth.user.user_login === 'pm@arteldv.ru') {
      text = 'Рады снова видеть тебя, Катя!'
    }
    return (
      <div className="jumbotron">
        <h1>{text}</h1>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

export default connect(mapStateToProps)(Greetings);



// WEBPACK FOOTER //
// ./src/components/Greetings.js